@if (loading()) {
  <mat-spinner/>
} @else {
  <app-home-main/>

  <app-home-calculator/>

  <app-home-telegram-mini-app
  />

  <app-home-start-trading
    [qrData]="qrData().qrApp1"
  />

  <app-home-news [newsList]="newsList()"/>

  <app-home-application
    [qrData]="qrData().qrApp2"
  />
}

